import styled from '@emotion/styled';
import { icons } from '@assets/icons';
import { CheckBoxProps } from '@components/atoms/Inputs/Input/index';

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #555555;

  &.lvo-setting {
    flex-direction: row-reverse;
    & input[type='text'] {
      width: 70px;
      height: 29px;
      margin-left: 10px;
    }
    & .inner-label {
      margin-top: 7px;
    }
  }

  &[data-type='radio'],
  &[data-type='checkbox'] {
    align-items: center;

    &:hover input:not(:disabled) ~ label {
      border: 1px solid #7fe200;
    }
  }
  & > label {
    cursor: pointer;
  }
  &[data-disable='true'] {
    & input {
      &:checked {
        & ~ label {
          border-color: #bdbdbd;
          background-color: #bdbdbd;
        }
      }
    }
    & > label {
      cursor: default;
    }
  }

  ${(props: CheckBoxProps) => props.styles};
`;
export const InputLabel = styled.div`
  @keyframes placeholderHover {
    from {
      padding-top: 7px;
      font-size: 14px;
      line-height: 20px;
    }
    to {
      padding-top: 0;
      font-size: 10px;
      line-height: 14px;
    }
  }

  display: block;
  position: relative;
  width: 100%;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &[data-type='text'],
  &[data-type='date'],
  &[data-type='password'] {
    & > label {
      display: none;
    }
  }

  &[data-type='radio'],
  &[data-type='checkbox'] {
    width: 14px;
    height: 14px;
    margin: auto 10px;
  }
  input {
    &:focus,
    &:focus:hover {
      outline: none;
      border-color: #00bf00 !important;
    }

    &:is([value='']) ~ label {
      color: #999999;
      padding-top: 7px;
      font-size: 14px;
      line-height: 20px;
    }

    &:is([value='']):hover ~ label {
      border-color: #7fe200;
    }

    &:not([value='']) ~ label {
      color: #555;
      animation-iteration-count: 0 !important;
      padding-top: 0;
      font-size: 10px;
      line-height: 14px;
    }
    &:focus ~ label {
      color: #00bf00;
      padding-top: 0;
      font-size: 10px;
      line-height: 14px;
      animation: placeholderHover 0.3s ease;
    }
    &:hover:not(:disabled) {
      border-color: #777;
    }

    &[data-invalid]:not([data-invalid='']),
    &:focus[data-invalid]:not([data-invalid='']),
    &:active:not([data-invalid='']) {
      // border-color: #ff4c4c !important;
      & ~ label {
        color: #ff4c4c;
      }
    }

    &[data-invalid]:is([data-invalid='capslock']),
    &:focus[data-invalid]:is([data-invalid='capslock']),
    &:active:is([data-invalid='capslock']) {
      border-color: #fbbb3a !important;
      & ~ label {
        color: #fbbb3a !important;
      }
    }

    &:focus:not(:disabled):is([data-invalid='']),
    &:active:not(:disabled) {
      // border-color: #00bf00 !important;
      & ~ label {
        color: #00bf00 !important;
      }
    }
    &:disabled {
      cursor: not-allowed;
      background-color: #eeeeee !important;
      color: rgba(153, 153, 153, 0.5) !important;
      & ~ label {
        cursor: default;
        border-color: #999;
        background: #c4c4c4;
        color: #999999;
      }
    }
  }
  input[type='text'],
  input[type='date'],
  input[type='password'] {
    box-sizing: border-box;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    color: #555;
    width: 100%;
    height: 40px;
    font-family: Noto Sans KR;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    padding-left: 16px;
  }
  //input[type='password'] {
  //  ::-webkit-input-placeholder {
  //    color: #999999;
  //  }
  //}
  input[type='radio'],
  input[type='checkbox'] {
    cursor: pointer;
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }

  input[type='date'] {
    color: #555555;
    ::-webkit-calendar-picker-indicator {
      cursor: pointer;
      background-image: url(${icons.datepicker_range});
      margin-right: 16px;
    }
    &[data-range='to' i] {
      :before {
        content: '~';
      }
    }
  }

  input:checked ~ label {
    background-color: #00bf00;
    border: 1px solid #00bf00;
  }

  input:checked:hover ~ label {
    background-color: #7fe200;
    border: 1px solid #7fe200;
  }

  input:checked ~ label:before,
  input:checked ~ label:after {
    display: block;
  }

  label {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    margin: auto;
    height: 14px;
    width: 14px;
    background: unset;

    border: 1px solid #555555;
    &[data-type='text'],
    &[data-type='date'] {
      display: none;
    }
  }

  label[data-type='checkbox'] {
    border-radius: 4px;
    :after {
      content: '';
      position: absolute;
      display: none;
      left: 1px;
      top: 1px;
      width: 8px;
      height: 4px;
      border-left: 2px solid #fff;
      border-bottom: 2px solid #fff;
      transform: rotate(-45deg);
    }
  }
  label[data-type='radio'] {
    border-radius: 14px;
    :before {
      content: '';
      position: absolute;
      display: none;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      height: 6px;
      width: 6px;
      border-radius: 50%;
      background-color: white;
    }
  }
`;

export const InnerLabel = styled.label`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  & > div {
    margin-left: 10px;
  }
`;
